import DynamicInsightsTable from './Table';
export default DynamicInsightsTable;
